import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { getChatBotNewSchema } from "../../thunks/common-thunks/commonThunk";

const initialState = {
  isChatLoading: false,
  error: null,
  chatResponse: null,
};

export const chatBotSchemaSlice = createSlice({
  name: "chatBotSchema",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChatBotNewSchema.pending, (state) => {
        state.isChatLoading = true;
        state.error = null;
      })
      .addCase(getChatBotNewSchema.fulfilled, (state, action) => {
        state.isChatLoading = false;
        state.chatResponse = action.payload;
      })
      .addCase(getChatBotNewSchema.rejected, (state, action) => {
        state.isChatLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default chatBotSchemaSlice.reducer;
